import React, { useContext, useMemo } from 'react';

import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { Col } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { PromoGoToCart } from '../../../promo-go-to-cart/PromoGoToCart';

import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { buildAddToCartRequest, buildAddToCartOverlayOptions } from '../../../../utils/promo-cart-utils';

import './PromoAddItemsToCart.scss';

export const PromoAddItemsToCart = () => {
  const { channel } = useContext(ExperienceContext);
  const {
    bogoSelectedProduct, promoCartItemsObj, freeItemInCart, isCartLoading, setIsCartLoading
  } = usePromoCart();
  const {
    anchorItem, allFulfillableProductsAndAnchor, store, analyticsSharedSection
  } = usePromoModel();

  const freeProductInfo = allFulfillableProductsAndAnchor.get(freeItemInCart?.itemId);
  const selectedItem = freeProductInfo || bogoSelectedProduct;

  const anchorCartItemDetails = useMemo(() => {
    const { CartRequest } = buildAddToCartRequest({
      product: anchorItem,
      promoItemModel: promoCartItemsObj[anchorItem.itemId],
      desiredQuantity: 1,
      store,
    });

    return CartRequest.itemDetails;
  }, [anchorItem, promoCartItemsObj, store]);

  const freeCartItemDetails = useMemo(() => {
    if (!bogoSelectedProduct) return [];

    const { CartRequest } = buildAddToCartRequest({
      product: bogoSelectedProduct,
      promoItemModel: promoCartItemsObj[bogoSelectedProduct.itemId],
      desiredQuantity: 1,
      store,
    });

    return CartRequest.itemDetails;
  }, [bogoSelectedProduct, promoCartItemsObj, store]);

  const addToCartOptions = useMemo(() => {
    const freeItemDetails = freeCartItemDetails[0];
    const overrides = {
      bogo: freeItemDetails ? {
        itemDetails: {
          itemId: freeItemDetails.itemId,
          fulfillmentLocation: freeItemDetails.fulfillmentLocation,
          fulfillmentMethod: freeItemDetails.fulfillmentMethod,
          quantity: freeItemDetails.quantity,
        }
      } : null,
      hidden: false,
      sharedSection: analyticsSharedSection,
      component: 'add both',
    };

    return buildAddToCartOverlayOptions(channel, overrides);
  }, [freeCartItemDetails, channel, analyticsSharedSection]);

  return (
    <>
      {selectedItem && (
        <Col fallback={12} flatten className="promo-add-items u__bold">
          {freeItemInCart && (
            <PromoGoToCart />
          )}
          {!freeItemInCart && (
            <AddToCart
              cartReqParams={[...anchorCartItemDetails, ...freeCartItemDetails]}
              cartOptions={addToCartOptions}
              disabled={isCartLoading}
              onClick={() => setIsCartLoading(true)}
              onError={() => setIsCartLoading(false)}
              onFail={() => setIsCartLoading(false)}
              onSuccess={() => setIsCartLoading(false)}
            >
              Add Both to Cart
            </AddToCart>
          )}
        </Col>
      )}
    </>
  );
};

PromoAddItemsToCart.displayName = 'PromoAddItemsToCart';
